<script lang="ts">
    import Notification from "./Notification.svelte";

    import { notifications } from "./notification";
</script>

<!----------------------------------------------------------------------------->

<div class="notifications">
  {#each $notifications as notification (notification.id)}
    <Notification {notification} />
  {/each}
</div>

<!----------------------------------------------------------------------------->

<style>
  .notifications {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 1000;
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-end;
  }
</style>
